import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import api from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Password reset email sent!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen noise-bg">
      <Navbar />
      
      <div className="pt-32 pb-12">
        <div className="max-w-md mx-auto px-4">
          <div className="bg-[#0A0A0A] border border-border rounded-lg p-8">
            <Link to="/login" className="inline-flex items-center gap-2 text-muted-foreground hover:text-[#00E055] mb-6">
              <ArrowLeft className="w-4 h-4" />
              Back to Login
            </Link>

            <div className="flex items-center gap-3 mb-6">
              <Mail className="w-8 h-8 text-[#00E055]" />
              <h1 className="text-3xl font-black tracking-tighter uppercase" style={{fontFamily: 'Unbounded, sans-serif'}}>
                FORGOT <span className="text-[#00E055]">PASSWORD</span>
              </h1>
            </div>

            {!sent ? (
              <>
                <p className="text-muted-foreground mb-6">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="email">Email Address</Label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder="your@email.com"
                      className="bg-muted border-border"
                      disabled={loading}
                    />
                  </div>

                  <Button
                    type="submit"
                    className="w-full bg-[#00E055] hover:bg-[#00E055]/90 text-black font-bold"
                    disabled={loading}
                  >
                    {loading ? 'SENDING...' : 'SEND RESET LINK'}
                  </Button>
                </form>
              </>
            ) : (
              <div className="text-center py-6">
                <div className="w-16 h-16 bg-[#00E055]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mail className="w-8 h-8 text-[#00E055]" />
                </div>
                <h2 className="text-xl font-bold mb-3">Check Your Email</h2>
                <p className="text-muted-foreground mb-6">
                  If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.
                </p>
                <p className="text-sm text-muted-foreground mb-4">
                  Didn't receive the email? Check your spam folder or try again.
                </p>
                <Button
                  onClick={() => setSent(false)}
                  variant="outline"
                  className="w-full"
                >
                  TRY DIFFERENT EMAIL
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
